import script from "./4.TakingMedicationsAndOthers.vue?vue&type=script&setup=true&lang=ts"
export * from "./4.TakingMedicationsAndOthers.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__